import { render, staticRenderFns } from "./work_order_assign.vue?vue&type=template&id=1962e255&scoped=true&"
import script from "./work_order_assign.vue?vue&type=script&lang=js&"
export * from "./work_order_assign.vue?vue&type=script&lang=js&"
import style0 from "./work_order_assign.vue?vue&type=style&index=0&id=1962e255&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1962e255",
  null
  
)

export default component.exports